import { render, staticRenderFns } from "./MdSelect.html?vue&type=template&id=37dd0259&external"
import script from "./MdSelect.ts?vue&type=script&lang=ts&external"
export * from "./MdSelect.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports